module.exports = __webpack_public_path__ + "media/images/mobile/solutions/19-0b35bff07c6989b90c673233d39c2517.jpg";